<template>
    <transition name="slide-fade">
        <div class="otp-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="topbar">
                    <img class="absolute m-auto top-2 left-0 right-0 w-20" src="@/assets/icon-tipcoin.png" />
                </div>
                <div class="bg-white rounded-25 mx-3 p-10 min-h-84vh
                      s:min-h-83vh
                      xs:min-h-80vh xs:p-8
                      tall:min-h-86vh">
                    <div class="text-24 text-144394 text-center">{{lbl.otp.headline}}</div>
                    <div class="my-3 text-20 text-666666 text-center">{{lbl.otp.contact_number_lbl}}</div>
                    <div class="mb-3 text-34 text-144394 text-center">{{displayContantNumber}}</div>

                    <div class="mb-4 text-20 text-666666 text-center">{{lbl.otp.refcode_lbl}}{{refcode}}</div>

                    <OtpInput
                        class="mb-4"
                        v-model:inputValid="isOtpValid" />

                    <div class="flex items-center">

                        <div class="mb-4 ml-auto mr-2 font-main-medium text-20 text-1c3e95 text-center underline"
                            @click="resendOtp()">
                            {{lbl.otp.resend_otp}}
                        </div>
                        <div class="mb-4 mr-2 text-20 text-1c3e95">-</div>
                        <CountDownTimer
                            id="otp_timeleft"
                            class="mb-4 text-666666 text-20 text-center mr-auto"
                            v-model:inputIsExpire="isOtpExpire"
                            :expireIn="expireIn"
                            :timeLeftLbl="lbl.otp.timeleft" />
                    </div>

                    <div class="mb-4 font-main-medium text-20 text-pink text-center"
                        v-if="isError">{{errorMsg}}</div>

                    <div class="grid gap-3">
                        <!-- <SecondaryButton
                            btnId="cancel_btn"
                            :btnMsg="btnCancel"
                            @onClick="onCancel()" /> -->

                        <div @click="onOk()"
                            :isBtnDisable="!isValid"
                            class="text-white text-20 mt-16 bg-1c3e95 w-full text-center m-auto p-3 rounded-3xl shadow-btn">
                            {{btnOk}}
                        </div>
                        <!-- <PrimaryButton
                            btnId="confirm_btn"
                            :btnMsg="btnOk"
                            :isBtnDisable="!isValid"
                            @onClick="onOk()" /> -->
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
// helper
import Util from '@/helper/Utility.js';
// mixin
import LocaleMixin from "@/mixin/LocaleMixin";
// component
import OtpInput from "@/components/Authen/Otp/OtpInput.vue";
import CountDownTimer from '@/components/Utility/CountDownTimer.vue';
// import PrimaryButton from '@/components/Button/PrimaryButton.vue';
// import SecondaryButton from '@/components/Button/SecondaryButton.vue';
import OtpProvider from '@/module/Register/provider/OtpProvider.js';
export default {
    name: 'OtpModal',
    mixins: [LocaleMixin],
    // inject: ['OtpProvider'],
    components: {
        OtpInput,
        CountDownTimer,
        // PrimaryButton,
        // SecondaryButton
    },
    props: {
        controller: { type: Object }
    },
    computed: {
        displayContantNumber: function () {
            // return Util.contactNumberFormat(this.OtpProvider.state.contact_number, '-');
            return Util.contactNumberFormat("0838019751", '-');
        },
        expireIn: function () {
            // return this.OtpProvider.state.expireIn;
            return "";

        },
        refcode: function () {
            // return this.OtpProvider.state.refcode;
            return "ZAX555"
        },
        isValid: function () {
            return this.isOtpValid && !this.isOtpExpire;
        }
    },
    data: function () {
        return {
            open: false,

            isOtpExpire: false,
            isOtpValid: false,

            isError: false,
            errorMsg: '',
            btnOk: '',
            btnCancel: '',
            busModal: null
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
        this.busModal.on('showError', this.showError);
        this.busModal.on('onResendOtp', this.onResendOtp);
    },
    methods: {
        //#region event
        onOk: function () {
            if (!this.isValid) return;
            this.isError = false;
            this.errorMsg = '';
            this.controller.sendCallbackOk();
        },
        onCancel: function () {
            this.isError = false;
            this.errorMsg = '';

            this.hide();
            this.controller.sendCallbackCancel();
        },
        //#endregion event
        //#region method
        show: function (config) {
            this.btnOk = config.btnOk;
            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }

            this.btnCancel = config.btnCancel;
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        showError: function (error) {
            this.isError = true;
            this.errorMsg = error.msg;
        },
        //#endregion method
        //#region resend otp
        resendOtp: function () {
            this.isError = false;
            this.errorMsg = '';
            this.controller.sendCallbackResendOtp();
        },
        onResendOtp: function () {
            this.isOtpExpire = false;
            OtpProvider.state.otp = '';
        }
        //#endregion resend otp
    }
}
</script>
<style lang="scss">
@import '@/style/base/base.scss';
@import "@/style/modal.scss";
#otp_timeleft {
    span {
        color: red
    }
}
.otp-modal {
    @extend %modal;

    .modal-content {
        width: 100%;
        height: 100vh;
        border-radius: 25px;
        background-image: linear-gradient(to bottom, #1c3e95 2%, #1c3d91 2%, #1a326e 16%);
        // overflow: hidden;

        @include mobile {
            width: 100%;
            // padding: 10px;
        }
    }
}
</style>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import "@/style/modal.scss";
.otp-modal {

    .topbar {
        background-image: url("../../../../assets/bg-head.png");
        min-height: 100px;
        background-size: 100% 100%;
        border-radius: 25px;
        padding-top: 5px;
    }
}
</style>
